import React from 'react';
import GameCard from './GameCard';
import { featuredGames } from '../data/mockData';

const GamesShowcase = () => {
  return (
    <section id="games" className="py-24 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Make Games People
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent"> Love</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            From arcade shooters to cinematic 3D worlds — create any genre with a prompt, then share it and let others remix it
          </p>
        </div>

        {/* Games Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredGames.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default GamesShowcase;